module.exports = __webpack_public_path__ + "img/logo_placeholder.ca198e3d.png";